<template>
  <form-view v-loading="loading" url="/car/device/update" type="device" :data-form="dataForm">
    <div class="section-title-row">
      <div class="title">车辆基本信息</div>
      <div class="line"></div>
    </div>
    <el-row :gutter="25">
      <el-col :span="12">
        <el-form-item label="自编号" prop="number">
          <el-input disabled v-model="dataForm.number"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="车牌号码" prop="licensePlate">
          <el-input disabled v-model="dataForm.licensePlate"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="25">
      <el-col :span="12">
        <el-form-item label="原终端号" prop="oldCarDeviceId">
          <el-input disabled v-model="dataForm.oldCarDeviceId"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="通信卡号" prop="oldSimCardNumber">
          <el-input disabled v-model="dataForm.oldSimCardNumber"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row><div style=" padding-bottom: 20px;font-weight: 666;">新的车辆终端信息：</div></el-row>
    <el-row :gutter="25">
      <el-col :span="12">
        <el-form-item label="新终端号" prop="carDeviceId">
          <el-input v-model="dataForm.carDeviceId"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="通信卡号" prop="simCardNumber">
          <el-input v-model="dataForm.simCardNumber"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </form-view>
</template>

<script>
import FormView from '@/components/templates/form-view'

export default {
  name: 'car-car-device',

  components: { FormView },

  data () {
    return {
      loading: false,
      dataForm: {
        id: '',
        number: '',
        oldCarDeviceId: '',
        oldSimCardNumber: '',
        carDeviceId: '',
        simCardNumber: ''
      }      
    }
  },

  created () {
    this.init()
  },

  methods: {
    async init () {
      const id = this.$route.query.id
      if (id) {
        this.loading = true
        const data = await this.$http({
          url: this.$http.adornUrl('/car/getById'),
          method: 'post',
          data: id
        })
        if (data && data.code === 200) {
          this.dataForm = data.datas
          this.dataForm.oldCarDeviceId = data.datas.carDeviceId
          this.dataForm.oldSimCardNumber = data.datas.simCardNumber
          this.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bracket-area {
  .el-form-item__content {
    white-space: nowrap;
    .el-input {
      width: 80%;
    }
    .el-input + label {
      margin-left: 10px;
    }
  }
}
.flex-row {
  margin: 20px 0;
  display: flex;
  align-items: center;
  .el-select,
  .el-date-editor {
    width: 150px;
    flex: 0 0 auto;
  }
  label {
    margin: 0 10px;
    white-space: nowrap;
  }
  .el-input.remark {
    flex: 1;
    width: auto;
  }
  .icon {
    font-size: 20px;
    margin-left: 10px;
    cursor: pointer;
    color: #666;
    &:hover {
      color: #999;
    }
  }
}
.license-area {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-around;
}
</style>
